import React from 'react';

import { cn } from './cn';

export interface MicrosoftLogoProps {
  className?: string;
}

export const MicrosoftLogo: React.FC<MicrosoftLogoProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      className={cn('size-5', className)}
    >
      <title>Microsoft Logo</title>
      <rect x="2" y="2" width="12" height="12" fill="#f25022" />
      <rect x="2" y="16" width="12" height="12" fill="#00a4ef" />
      <rect x="16" y="2" width="12" height="12" fill="#7fba00" />
      <rect x="16" y="16" width="12" height="12" fill="#ffb900" />
    </svg>
  );
};
